import React from 'react';
import { ArcCircularProgressProps } from './types';
import { CircularProgress } from '@mui/material';

const ArcCircularProgress: React.FC<ArcCircularProgressProps> = (props) => {
  return <CircularProgress color='brand' size={22} {...props} />;
};

export default ArcCircularProgress;